import queryString from 'query-string';

import { api, type IFetchApiProps } from './api';

export const QK_FETCH_PLATFORM_SETTINGS = 'qk_fetchPlatformSettings';

interface IPlatformSettingsResponse {
  currency: string;
  currencySign: string;
  taxRatePercentage: number;
  platformFeePercentage: number;
}

function getPlatformSettings({
  signal,
}: IFetchApiProps): Promise<IPlatformSettingsResponse> {
  return api.get(
    queryString.stringifyUrl({
      url: '/platform_settings',
    }),
    { signal },
  );
}

export const settingApi = {
  getPlatformSettings,
} as const;
